// src/components/CV/SectionReorder.jsx
import React from 'react';

const SectionReorder = ({ sectionOrder, onMoveUp, onMoveDown }) => {
    const sectionLabels = {
        summary: 'Professional Summary',
        education: 'Education',
        experience: 'Work Experience',
        skills: 'Skills',
        certifications: 'Certifications & Awards',
        languages: 'Languages'
    };

    const sectionIcons = {
        summary: 'fa-file-alt',
        education: 'fa-graduation-cap',
        experience: 'fa-briefcase',
        skills: 'fa-code',
        certifications: 'fa-certificate',
        languages: 'fa-language'
    };

    return (
        <div className="bg-white rounded-xl shadow-md p-4 mb-6">
            <h3 className="font-bold text-gradpath-dark mb-3 flex items-center gap-2">
                <i className="fas fa-arrows-alt text-gradpath-green"></i>
                Section Order
            </h3>
            <p className="text-xs text-gray-500 mb-3">
                Reorder sections by moving them up or down
            </p>
            <div className="space-y-1">
                {sectionOrder.map((sectionId, index) => (
                    <div
                        key={sectionId}
                        className="flex items-center justify-between bg-gray-50 px-3 py-2 rounded-lg border border-gray-200"
                    >
                        <div className="flex items-center gap-2">
                            <i className={`fas ${sectionIcons[sectionId] || 'fa-file'} text-gradpath-green w-5`}></i>
                            <span className="text-sm font-medium text-gray-700">
                                {sectionLabels[sectionId] || sectionId}
                            </span>
                        </div>
                        <div className="flex gap-1">
                            <button
                                onClick={() => onMoveUp(index)}
                                disabled={index === 0}
                                className={`px-2 py-1 rounded text-xs transition ${
                                    index === 0
                                        ? 'text-gray-300 cursor-not-allowed'
                                        : 'text-gray-500 hover:bg-gray-200 hover:text-gray-700'
                                }`}
                                title="Move Up"
                            >
                                <i className="fas fa-chevron-up"></i>
                            </button>
                            <button
                                onClick={() => onMoveDown(index)}
                                disabled={index === sectionOrder.length - 1}
                                className={`px-2 py-1 rounded text-xs transition ${
                                    index === sectionOrder.length - 1
                                        ? 'text-gray-300 cursor-not-allowed'
                                        : 'text-gray-500 hover:bg-gray-200 hover:text-gray-700'
                                }`}
                                title="Move Down"
                            >
                                <i className="fas fa-chevron-down"></i>
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SectionReorder;